import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import { IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PersonIcon from '@mui/icons-material/Person';
import UserFiltersForm from './UserFiltersForm';
import { useUserState } from '../../../hook/customerHook';
import { blue } from '@mui/material/colors';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.paper,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	button: {
		flex: 1,
		color: blue[900],
		margin: 10,
		justifyContent: 'center',
		alignSelf: 'center'
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff'
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500]
	},
	content: {
		display: 'flex',
		padding: theme.spacing(0),
		overflowX: 'visible'
	},
	filterBtn: {
		marginTop: '8px',
		textTransform: 'none',
		letterSpacing: 'normal',
		fontWeight: 'normal'
	}
}));

const DialogTitle = ({ children, onClose, ...other }) => {
	const classes = useStyles();
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}
					size="large"
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
};

export default function UserFilters({
	refreshListings,
	restoredFilters,
	editAssignedTaskVisible,
	assignMyself,
	setHasArea
}) {
	const [open, setOpen] = useState(false);
	const classes = useStyles();
	const [userState, dispatchUser] = useUserState();

	const userFilters = userState.userFilters;
	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

	const filtersLength = (filters) => {
		return Object.keys(filters).length;
	};

	return (
		<React.Fragment>
			<Grid item justifyContent="center" alignItems="center">
				<Button
					variant="outlined"
					startIcon={<PersonIcon />}
					onClick={handleClickOpen}
					className={classes.filterBtn}
					style={{
						color: userFilters && filtersLength(userFilters) ? '#02838D' : '#004F2B',
						borderColor:
							userFilters && filtersLength(userFilters) ? '#02838D' : '#004F2B'
					}}
				>
					User filters{' '}
					{userFilters && filtersLength(userFilters)
						? `(${filtersLength(userFilters)})`
						: ''}
				</Button>
				<Dialog
					open={open}
					onClose={handleClose}
					aria-labelledby="search"
					scroll="paper"
					fullScreen={fullScreen}
				>
					<DialogTitle id="search" onClose={handleClose} className={classes.root}>
						{'Filters'}
					</DialogTitle>
					<DialogContent dividers className={classes.content}>
						<UserFiltersForm
							refreshListings={refreshListings}
							restoredFilters={restoredFilters}
							editAssignedTaskVisible={editAssignedTaskVisible}
							assignMyself={assignMyself}
							handleClose={handleClose}
							setHasArea={setHasArea}
						/>
					</DialogContent>
				</Dialog>
			</Grid>
		</React.Fragment>
	);
}
